import fetcher from '../utils/api';

const emailVerificationService = {
  verifyEmail: async (token, user_id) => fetcher(`verify_email/`, 'POST', false, { token, user_id }),
  sendVerificationEmail: async () => fetcher(`verify_email/resend/`, 'POST', true)
};

export default emailVerificationService;
